/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-28 16:22:34
 * @LastEditors: zhaoyuanbang zhaoyuanbang@longfor.com
 * @LastEditTime: 2025-09-04 10:39:08
 * @FilePath: /qd-c4-yunjing-web/src/router/modules/home.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import { RouteRecordRaw } from 'vue-router';

const { VITE_APP_ASTM_URL } = import.meta.env;
export const astmRoutes: RouteRecordRaw[] = [

  {
    path: '/astm',
    name: 'astm-root',
    // component: Layout,
    meta: {
      authCodes: ['ASTM'],
      targetUrl: VITE_APP_ASTM_URL,
    },
    children: [
    ],
  }
];
